module.exports = __webpack_public_path__ + "img/sprite.6fb97fe5.svg";